import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
    Box,
    Button,
    Breadcrumbs,
    Link as MuiLink,
    Stack,
    Typography,
} from "@mui/material";
import SubjectsAdminPanel from "./SubjectsAdminPanel";

const SubjectsAdminPage = () => {
    const { classId } = useParams();
    const navigate = useNavigate();

    const [selectedSubjectSlug, setSelectedSubjectSlug] = useState("");

    const handleClassChange = (nextClassId) => {
        navigate(`/manage-portal-9f3a/classes/${nextClassId}/subjects`);
    };

    const goToAuthors = () => {
        if (!selectedSubjectSlug) return;
        navigate(
            `/manage-portal-9f3a/classes/${classId}/subjects/${selectedSubjectSlug}/authors`
        );
    };

    return (
        <Stack spacing={2}>
            <Breadcrumbs>
                <MuiLink
                    underline="hover"
                    color="inherit"
                    onClick={() => navigate("/manage-portal-9f3a")}
                    sx={{ cursor: "pointer" }}
                >
                    Адмінка
                </MuiLink>
                <Typography color="text.primary">
                    Клас {classId}
                </Typography>
                <Typography color="text.primary">
                    Предмети
                </Typography>
            </Breadcrumbs>

            <SubjectsAdminPanel
                classId={String(classId)}
                onClassIdChange={handleClassChange}
                selectedSubjectSlug={selectedSubjectSlug}
                onSelectSubject={setSelectedSubjectSlug}
            />

            <Box>
                <Button
                    variant="contained"
                    disabled={!selectedSubjectSlug}
                    onClick={goToAuthors}
                >
                    Автори для предмета
                </Button>
            </Box>
        </Stack>
    );
};

export default SubjectsAdminPage;
